import { render, staticRenderFns } from "./FileLoader.vue?vue&type=template&id=f85387a2&scoped=true&lang=pug"
import script from "./FileLoader.vue?vue&type=script&lang=js"
export * from "./FileLoader.vue?vue&type=script&lang=js"
import style0 from "./FileLoader.vue?vue&type=style&index=0&id=f85387a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85387a2",
  null
  
)

export default component.exports